import React from 'react';
import './completeSolutionButton.scss'

function CompleteSolutionButton(props) {
  const className = `cs-button__${props.type}`

  return (
    <button
      className={className}
      onClick={props.onClick}
      style={props.style}
    >
      {props.start && <img style={{marginRight: '4px'}} src={props.start} alt='' loading="lazy"/>}
      {props.label}
      {props.end && <img style={{marginRight: '4px'}} src={props.end} alt='' loading="lazy"/>}
    </button>
  );
}

export default CompleteSolutionButton;